import { _axios } from "../../../Utils/Axios/axios";

export const getUserNotifications = async (userToken: string) => {
  return _axios.get("/user/notifications", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
